import React from "react";

// (2026-10) Sector del prospecto (Privado / Gobierno). Los prospectos dados de
// alta antes de este campo vienen en "NA" y se muestran como "Sin sector".
export const SECTORES = ["Privado", "Gobierno"];

export const sectorDe = (prospecto) =>
  SECTORES.includes(prospecto?.sector) ? prospecto.sector : "";

const COLOR = { Privado: "#2a78d6", Gobierno: "#8a6d1f" };

export const BadgeSector = ({ prospecto }) => {
  const s = sectorDe(prospecto);
  if (!s) return <span className="text-muted">-</span>;
  return (
    <span className="badge" style={{ backgroundColor: COLOR[s], color: "#fff" }}>
      {s}
    </span>
  );
};

// Filtro de sector: "" = todos, "sin" = sin sector capturado
export const pasaFiltroSector = (prospecto, filtro) =>
  !filtro || (filtro === "sin" ? !sectorDe(prospecto) : sectorDe(prospecto) === filtro);

export const OpcionesFiltroSector = () => (
  <>
    <option value="">Todos los sectores</option>
    {SECTORES.map((s) => (
      <option key={s} value={s}>{s}</option>
    ))}
    <option value="sin">Sin sector</option>
  </>
);
